@if (answers.length > 0) {
  <div>
    <div class="answers-summary">
      <div class="block-wrapper">
        <dl class="mb-0">
          @for (answer of answers; track answer) {
            <div class="row" app-answer [question]="answer.questionText"
            [answer]="answer.answerText" (goBack)="goBack(answer.question)"></div>
          }
        </dl>
      </div>
    </div>
  </div>
}